module.exports = __webpack_public_path__ + "static/media/coins.b3a90739.png";